(ns web3.screens.welcome
  (:require ["@vimeo/player" :as VimeoPlayer]
            [web3.view :as v]
            [web3.i18n :as i]
            [web3.routing.core :as routing]
            [web3.components.widgets :as widgets]
            [web3.components.branch :as branch]
            [web3.hints.core :as hints]
            [re-frame.core :as rf]
            [web3.constants :as constants]
            [web3.utils :as utils]
            [web3.components.text :as text]
            [reagent.core :as r]
            [web3.env :as env]
            [web3.icons.shapes :as shapes]
            [web3.auth.api :as auth]))

(def primary-button-style
  {:width "100%"
   :color :black
   :margin-top "10px"
   :background "rgba(255,255,255,0.65)"
   :border "1px solid #e2e2e2"})

(v/defview start
  {:header false
   :modal-props {:style {:background-image "url(/images/homeserve-background-img.jpg)"
                         :background-size "cover"
                         :background-repeat "no-repeat"}}
   :component-did-mount
   (fn [this]
     (rf/dispatch [:tracking/registered])
     (rf/dispatch [:tracking/referred])
     (branch/track! "web-onboarding")
     (hints/activate-hint-mode!))}
  []
  [:div.pad-all-3.round-4.height-100p.flex.flex-column
   [:div {:style {:cursor :pointer}
          :on-click #(auth/logout!)}
    shapes/chevron-left]
   [:div.text-center.flex-none
    [:div.text-center.flex-none.welcome-text-title.weight-extra-light
     {:style {:margin-top "75px"
              :color (:welcome/text constants/colors)}}
     (i/to-do "Welcome to")]
    [:img {:src "/images/homeserve-logo-lowhouse.svg"
           :style {:width 290
                   :margin-top 55
                   :margin-bottom 25
                   :margin-right -4}}]]
   [:div.flex.height-50p
    [:div.flex.flex-column.flex-auto.justify-center
     [:div.text-size-17.weight-medium.pad-all-3.text-center
      {:style {:text-shadow "0 0 10px rgba(255,255,255,1), 0 0 15px rgba(255,255,255,1), 0 0 30px rgba(255,255,255,1)"}}
      (i/get :welcome/start-intro)]
     [widgets/black-button
      {:href (routing/path-for [:welcome/add.property])
       :class "text-white width-100p"}
      (i/get :i/start)]
     [:div.text-size-14.weight-medium.pad-all-3.text-center
      {:style {:cursor :pointer}
       :on-click #(auth/logout!)}
      (i/to-do "BACK")]]]])


(v/defview use-mobile-hint
  [{:keys [as-hint? left-text]}]
  (let [{:keys [state] :as this} (r/current-component)
        {:keys [status phone loading? error message]} @state
        send! #(do (swap! state assoc :loading? true)
                   (branch/send-sms! phone
                                     (fn [error]
                                       (swap! state merge (cond-> {:loading? false}
                                                                  error (assoc :error
                                                                               (branch/parse-branch-error error))
                                                                  (nil? error) (assoc :message (i/to-do "Success!")
                                                                                      :status :complete
                                                                                      :error nil))))))]
    [:div.cursor-pointer.bg-black.text-white.pad-h-3.text-size-13.flex.items-start.items-center.round-4.margin-bottom-1.relative.z-2
     {:on-click #(when (and (not= status :expanded)
                            (not= status :complete))
                   (swap! state assoc :status :expanded)
                   (utils/focus-first-input! this))}
     [:div.flex.items-center
      {:class (if (= status :expanded)
                "width-100p"
                "margin-h-auto")}
      (case status
        :expanded
        [:div.width-100p.relative
         [:div.absolute.pad-top-1.right-0.cursor-pointer.z-1
          {:on-click #(swap! state dissoc :status)}
          shapes/close-x]
         [text/input {:label (i/to-do "Phone Number")
                      :style {:color "white"}
                      :loading? loading?
                      :helptext [:div.text-white (or error message)]
                      :helptext-persistent? true
                      :on-key-down #(when (utils/save-event? %)
                                      (.stopPropagation %)
                                      (.preventDefault %)
                                      (send!))
                      :value phone
                      :on-change #(swap! state assoc :phone (.. % -target -value))}]
         [widgets/primary-button {:style (merge primary-button-style
                                                {:margin-bottom "10px"})
                                  :on-click send!} "Send SMS"]]

        :complete
        [:div.pad-all-2
         (i/to-do (str "Your link has been sent to " phone ". "))
         [:a.cursor-pointer.text-underline.block {:on-click #(swap! state assoc :status :expanded)}
          (i/to-do "Try Again")]]

        [:div.flex.items-center
         (when left-text
           [:div.ph2.flex-auto left-text])
         [widgets/primary-button (-> primary-button-style) (i/get :i/text-me)]])]]))

(v/defview get-mobile
  {:header false
   :modal-props {:style {:background-image "url(/images/homeserve-background-img.jpg)"
                         :background-size "cover"
                         :background-repeat "no-repeat"}}
   :component-did-mount
   (fn [this])}
  []
  [:div.pad-all-3.round-4.height-100p.flex.flex-column

   [:div.text-center.flex-none.welcome-text-title.weight-extra-light
    {:style {:padding-top "15%"
             :color (:welcome/text constants/colors)}}
    (i/to-do "Well Done")]
   [:div.flex.height-100p
    [:div.flex.flex-column.flex-auto.justify-center

     [:div.text-size-17.weight-medium.text-center.margin-h-auto.pad-top-2_5
      (i/to-do "Next, let's add some products.")]

     [:div.text-size-17.weight-medium.text-center.margin-h-auto.pad-top-3
      {:style {:max-width "210px"
               :text-shadow "0 0 10px rgba(255,255,255,1), 0 0 15px rgba(255,255,255,1), 0 0 30px rgba(255,255,255,1)"}}
      (i/to-do (str "Adding products is easiest with the " (:partner/name env/config) " mobile app."))]

     [:div.flex.margin-h-auto.pad-top-3
      [:img {:style {:max-height "200px"}
             :src "/images/iphonex.png"}]]


     [:div.width-100p.pad-top-3.flex
      [widgets/black-button
       {:href "https://itunes.apple.com/us/app/homeserve/id1455853537?ls=1&mt=8"
        :class "text-white width-100p"}
       [:img {:style {:position "relative"
                      :top "-4px"}
              :src "/images/button-appstore.svg"}]]]
     [:div.width-100p.pad-top-3.flex
      [widgets/black-button
       {:href "https://play.google.com/store/apps/details?id=com.homeserveapp.homeserve"
        :class "text-white width-100p"}
       [:img {:style {:position "relative"
                      :top "-5px"}
              :src "/images/button-googleplay.svg"}]]]
     [:div.width-100p.pad-top-3
      [use-mobile-hint]]
     [:div.width-100p.pad-top-4.flex
      [widgets/primary-button
       {:style primary-button-style
        :href (if-let [vimeo-id (:feature/welcome-vimeo-id env/config)]
                (routing/path-for :router/root [:home] ;;TODO Refactor this duped code from property.cljs
                                  :router/form-modal [:media/vimeo :vimeo-id vimeo-id])
                (routing/path-for {:router/root [:home]}))}
       (i/to-do "Continue in Browser")]]]]])



(v/defview vimeo-player
  {:header {:title "Welcome Video"}
   :modal-props {:wide? true
                 :min-height "none"}
   :component-did-mount
   (fn [{:as this
         state :state
         {:keys [vimeo-id]} :props}]
     (let [player (new VimeoPlayer "vimeo-player" #js {:autoplay false
                                                       :id vimeo-id
                                                       :playsinline false
                                                       :responsive true})
           redirect (routing/get-query :redirect)]
       (.on player "ended"
            #(routing/nav! redirect))
       (v/swap-silently! state assoc :player player)))
   :component-will-unmount
   (fn [{:keys [state]}]
     (.destroy (:player @state)))}
  [{:keys [vimeo-id]}]
  [:div
   [:div#vimeo-player]
   [:a.block.pad-all-3.text-uppercase.text-size-16.text-center.text-black.hover-text-black-hover
    {:href (routing/path-for :router/root [:home]
                             :router/form-modal nil)}
    "Skip"]])